module.exports = __webpack_public_path__ + "img/8ad8570.jpeg";